export const TYPES = ["before_5", "before_1", "due_day", "overdue"];
export const TYPE_LABEL = { before_5: "5 days before", before_1: "1 day before", due_day: "On due date", overdue: "Overdue follow-up" };
export const TYPE_HINT = {
  before_5: "Queued when the next EMI is 2–5 days away.",
  before_1: "Queued the day before the EMI is due.",
  due_day: "Queued on the EMI due date.",
  overdue: "Queued once per instalment after the due date has passed and it is still unpaid.",
};
export const SAMPLE_VALUES = {
  member_name: "Lakshmi Debbarma", shg_name: "Jagriti Mahila SHG", loan_id: "LN-2026-0001",
  emi_amount: "₹6,850", due_date: "05/11/2026", outstanding: "₹1,22,600",
};
export const fill = (tpl, vals) => tpl.replace(/\{(\w+)\}/g, (m, k) => (k in vals ? vals[k] : m));
export const toMeta = (tpl) => {
  const order = [];
  (tpl.match(/\{(\w+)\}/g) || []).forEach((m) => { if (!order.includes(m)) order.push(m); });
  return order.reduce((t, m, i) => t.split(m).join(`{{${i + 1}}}`), tpl);
};
